<template>
  <div v-loading="loading" class="log-wrapper">
    <div class="system-log">
      <Top title="系统维护日志">
      </Top>
      <!-- 表格 -->
      <el-table ref="table" v-loading="loading"
                :data="tableData" class="table" empty-text="暂无数据">
        <el-table-column label="维护时间" prop="createdTime" width="250px"></el-table-column>
        <el-table-column label="维护内容" prop="operation" min-width="146px">
          <template v-slot="scope">
            <div class="row-str">{{ scope.row.operation }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatorName" width="100px"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        class="pagination"
        :page-sizes="[15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListMixin from 'src/views/mixins/list'
import Top from '@/components/common/tableTop'
import { getCommonLogsApi } from './fetch'
export default {
  name: 'SystemPreserveLog',
  components: {
    Top,
  },
  mixins: [ListMixin],
  data () {
    return {
      filterForm: {
        logType: 3,
      },
      getListApi: getCommonLogsApi,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  overflow: auto
}
.system-log{
  padding: 0 40px 40px;
}
.row-str{
  @include ellipsis(1);
  white-space: pre-line;
}

</style>
